/* It's a search bar that filters the forms based on the input */
import React, { Component } from "react"
import { FormControl, Spinner } from "react-bootstrap"
import stateMutator from "src/pages/dynamic_forms/Utils/StateMutator"
import taskHelper from "../../taskHelper"
import "./TaskDynamicFormOptionsSearch.css"

interface Props {
    distributionGroup: Array<{ id: number, text: string, hashKey: string }>
    distributionGroupCopy: Array<{ id: number, text: string }>
    manageParentState: Function
}

interface State {
    input: string | null
    busy: boolean
}

class TaskDynamicFormOptionsSearch extends Component<Props, State> {

    typingTimeout: any = 0

    state = {
        input: null,
        busy: false
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
    an uncontrolled manner. */
    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(stateMutator.mutate(this.state, keys))
    }

    /* Filtering the forms based on the input. */
    filter = (input: string, distributionGroup: Array<{ id: number, text: string }>) => {
        let temp = []
        for (let i = 0; i < distributionGroup.length; i++) {
            const str = distributionGroup[i].text.toLowerCase()
            if (str.includes(input.toLowerCase())) {
                temp.push(distributionGroup[i])
            }
        }
        this.props.manageParentState([{ key: "distributionGroup", value: temp }])
        this.manageState([{ key: "busy", value: false }])
    }

    /* A debounce function. */
    debounce = (event: { target: { value: string } }) => {
        const input = event.target.value
        this.manageState([{ key: "input", value: input }, { key: "busy", value: true }])
        if (this.typingTimeout) {
            clearTimeout(this.typingTimeout)
        }
        this.typingTimeout = setTimeout(() => {
            if (input.length > 0) {
                this.filter(input, this.props.distributionGroupCopy)
            } else {
                this.props.manageParentState([{ key: "distributionGroup", value: this.props.distributionGroupCopy }])
                this.manageState([{ key: "busy", value: false }])
            }
        }, 500)
    }

    render() {

        const state = this.state
        const props = this.props
        const placeholder = props.distributionGroup.length > 0 ? `Search ${taskHelper.lookupItem(props.distributionGroup[0].hashKey)[2].ReferenceItem}` : "No Options..."

        // console.log("df_TaskDynamicFormOptionsSearch props", props)
        // console.log("df_SearhForms state", state)
        // console.log("df_TaskDynamicFormOptionsSearch placeholder", placeholder)

        return (
            <div className="TaskDynamicFormOptionsSearch">
                <div className="TaskDynamicFormOptionsSearchBusy">
                    {state.busy && <Spinner id="task-dynamic-forms-options-search-busy-spinner" animation="border" />}
                </div>
                <div className="TaskDynamicFormOptionsSearchInput">
                    <FormControl
                        onChange={this.debounce}
                        placeholder={placeholder}
                        value={this.state.input || ""}
                        type="text"
                    />
                </div>
            </div>
        )
    }
}

export default TaskDynamicFormOptionsSearch